import bulkSelection from './bulk-selection'
import companyAdmin from './company-admin'
import comment from './comment'
import companyMacrotrend from './company-macrotrend'
import companyMegatrend from './company-megatrend'
import companyMicrotrend from './company-microtrend'
import confirmationDialog from './confirmation-dialog'
import contactPerson from './contact-person'
import consentManagement from './consent-management'
import criteriaSet from './criteria-set'
import dashboard from './dashboard'
import dataTable from './data-table'
import dateRangeFilter from './date-range-filter'
import evaluation from './evaluation'
import exports from './exports'
import form from './form'
import footer from './footer'
import helpBar from './help-bar'
import innovationField from './innovation-field'
import insights from './insights'
import macrotrend from './macrotrend'
import microtrend from './microtrend'
import megatrend from './megatrend'
import navigation from './navigation'
import newFeatures from './new-features'
import post from './post'
import publicLink from './public-link'
import innovationProject from './innovation-project'
import profile from './profile'
import searchBar from './search-bar'
import searchAgent from './search-agent'
import rating from './rating'
import trial from './trial'
import threads from './threads'
import trendingTopic from './trending-topic'
import trendcall from './trendcall'
import trendfinder from './trendfinder'
import trendradar from './trendradar'
import trendSummary from './trend-summary'
import trendTree from './trend-tree'
import txMigration from './tx-migration'
import universeUpdate from './universe-update'
import workspace from './workspace'

export default {
    bulkSelection,
    comment,
    companyAdmin,
    companyMacrotrend,
    companyMegatrend,
    companyMicrotrend,
    confirmationDialog,
    contactPerson,
    consentManagement,
    criteriaSet,
    dashboard,
    dataTable,
    dateRangeFilter,
    evaluation,
    exports,
    form,
    footer,
    helpBar,
    innovationField,
    insights,
    macrotrend,
    microtrend,
    megatrend,
    navigation,
    newFeatures,
    post,
    innovationProject,
    profile,
    publicLink,
    searchBar,
    searchAgent,
    rating,
    trial,
    threads,
    trendingTopic,
    trendcall,
    trendfinder,
    trendradar,
    trendSummary,
    trendTree,
    txMigration,
    universeUpdate,
    workspace
}
